import { getCart, clearCart } from "../utils/cart";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles//Checkout.css"; // ⬅️ Optional for styling if needed

function Checkout() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({
    plot: "",
    street: "",
    city: "",
    state: "",
    pincode: "",
    landmark: "",
    payment: "cod"
  });
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      alert("Please log in to proceed to checkout.");
      window.location.href = "/login";
    } else {
      setItems(getCart());
    }
  }, []);

  const total = items.reduce((sum, item) => {
    const price = parseFloat(item.price.replace(/[₹,]/g, ""));
    return sum + price;
  }, 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return alert("Login required to place order");

    const fullAddress = `${form.plot}, ${form.street}, ${form.city}, ${form.state}, ${form.pincode}, Landmark: ${form.landmark}`;

    if (form.payment === "emi") {
      localStorage.setItem("checkout_order", JSON.stringify({
        user_id: user.id,
        cart: items,
        total,
        address: fullAddress
      }));
      return navigate("/emi-form"); // ⬅️ EMI Flow
    }

    const res = await fetch("https://kolibusiness.com/backend/api-checkout.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_id: user.id,
        cart: items,
        total,
        address: fullAddress,
        payment: form.payment
      })
    });

    const data = await res.json();
    alert(data.message);
    if (data.message === "Order placed successfully") {
      clearCart();
      navigate("/");
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <div className="checkout-container">
      <h2>🛒 Checkout</h2>
      {items.length === 0 ? (
        <p>No items in cart.</p>
      ) : (
        <>
          <ul className="checkout-items">
            {items.map((item, i) => (
              <li key={i}>
                {item.title} — {item.price}
              </li>
            ))}
          </ul>
          <h3>Total: ₹{total}</h3>

          <form className="checkout-form" onSubmit={handleSubmit}>
            <h4>Shipping Address</h4>
            <input name="plot" placeholder="Plot / House No." required onChange={handleChange} />
            <input name="street" placeholder="Street / Area" required onChange={handleChange} />
            <input name="city" placeholder="City" required onChange={handleChange} />
            <input name="state" placeholder="State" required onChange={handleChange} />
            <input name="pincode" placeholder="Pincode" required onChange={handleChange} />
            <input name="landmark" placeholder="Landmark (Optional)" onChange={handleChange} />

            <h4>Payment Method</h4>
            <label>
              <input type="radio" name="payment" value="cod" checked={form.payment === "cod"} onChange={handleChange} />
              Cash on Delivery
            </label>
            <label>
              <input type="radio" name="payment" value="emi" checked={form.payment === "emi"} onChange={handleChange} />
              EMI Option
            </label>

            <button type="submit" className="checkout-btn">Confirm Order</button>
          </form>
        </>
      )}
    </div>
  );
}

export default Checkout;
